import styled from "styled-components";
import { StandardTableSortablePropertyHeader } from "../../../components/tables/StandardTable";

const FixedHeader = styled(StandardTableSortablePropertyHeader)`
    ${({ width }) => width ? `width: ${width}%;` : ""}
`;

const AdviceRegisterTableHeader = ({ currentSort, sortTable }) => {
    const Header = ({ children, ...props }) => <FixedHeader
        {...props}
        sort={currentSort}
        sortTable={sortTable}
        className="text-truncate"
    >
        {children}
    </FixedHeader>

    return <thead>
        <tr>
            <Header width={10} property={'adviser'}>
                Adviser
            </Header>
            <Header width={17.5} property={'masterAccountName'}>Client</Header>
            <Header width={15} property={'reportName'}>Report</Header>
            <Header width={10} property={'author'}>
                Author
            </Header>
            <Header width={10} property={'complianceUser'}>
                Compliance Officer
            </Header>
            <Header width={5} property={'rejectCount'}>
                Rejected
            </Header>
            <Header width={7.5} property={'compliantDate'}>Compliance</Header>
            <Header width={7.5} property={'sentDate'}>Sent</Header>
            <Header width={10} property={'adminStatus'}>Admin</Header>
        </tr>
    </thead>
}

export default AdviceRegisterTableHeader;